import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Category {
  id: string;
  name: string;
  nameAr?: string;
  color?: string;
  icon?: LucideIcon;
}

interface CategoryTabsProps {
  categories: Category[];
  selectedCategory: string | null;
  onSelectCategory: (categoryId: string | null) => void;
}

export const CategoryTabs = ({ categories, selectedCategory, onSelectCategory }: CategoryTabsProps) => {
  return (
    <div className="bg-card border-b border-border px-4 py-3">
      <div className="flex items-center gap-2 overflow-x-auto">
        {/* All Products Tab */}
        <Button
          variant={selectedCategory === null ? 'default' : 'outline'}
          onClick={() => onSelectCategory(null)}
          className={cn(
            'h-12 min-w-[120px] whitespace-nowrap transition-all',
            selectedCategory === null && 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700'
          )}
        >
          <span className="font-medium">الكل / Tout</span>
        </Button>

        {/* Category Tabs */}
        {categories.map((category) => {
          const Icon = category.icon;
          const isSelected = selectedCategory === category.id;

          return (
            <Button
              key={category.id}
              variant={isSelected ? 'default' : 'outline'}
              onClick={() => onSelectCategory(category.id)}
              className={cn(
                'h-12 min-w-[120px] whitespace-nowrap transition-all gap-2',
                isSelected && 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700'
              )}
              style={
                isSelected
                  ? {}
                  : {
                      borderColor: category.color,
                      color: category.color,
                    }
              }
            >
              {Icon && <Icon className="w-4 h-4" />}
              <span className="font-medium">
                {category.nameAr} / {category.name}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};
